<template>
  <v-layout>
    <v-flex xs12>
      <v-chip
        v-if="value.is_published"
        color="green"
        text-color="white"
        small
      >Veröffentlicht</v-chip>
      <v-chip
        v-else
        color="grey"
        text-color="white"
        small
      >Entwurf</v-chip>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'PublishedChip',
  props: {
    value: {
      type: Object,
    },
  },
};
</script>
